var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showApp
    ? _c(
        "div",
        { staticClass: "app" },
        [
          _vm.$store.getters["authModule/isAuthenticated"]
            ? _c(
                "div",
                { staticClass: "app-wrapper" },
                [
                  _vm.showLoadingOverlay
                    ? _c("loading-overlay-component")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNavbar ? _c("pix-navbar") : _vm._e(),
                  _vm._v(" "),
                  _c("pix-sidebar"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "app-content body-content no-padding" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [_c("router-view")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("pix-audit-log-modal"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }